import Vue from 'vue'
import App from './App.vue'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'

Vue.use(ElementUI)

Vue.config.productionTip = false
// 全局引入http请求
import { post, get, patch, put } from '@/utils/http'
// 定义全局变量
Vue.prototype.$post = post
Vue.prototype.$get = get
Vue.prototype.$patch = patch
Vue.prototype.$put = put
new Vue({
  render: h => h(App),
}).$mount('#app')

import axios from 'axios'
axios.defaults.baseURL = "https://apiv2.yunpiaobox.com"
// axios.defaults.baseURL = "http://47.107.96.246:8086"
